import { configureStore } from "@reduxjs/toolkit";
import { crudApi } from "../services/crudApi";
import authReducer from "../features/authSlice";
import companyReducer from "../features/companySlice";
import companyUserReducer from "../features/companyUserSlice";
import platformUserReducer from "../features/platformUserSlice";
import roleReducer from "../features/roleSlice";
import moduleReducer from "../features/moduleSlice";
import rolePermissionReducer from "../features/rolePermissionSlice";
import subscriptionPlanReducer from "../features/subscriptionPlanSlice";
import branchReducer from "../features/branchSlice";
import branchSettingReducer from "../features/branchSettingSlice";
import signalrReducer from "../features/signalrSlice";
import customerReducer from "../features/customerSlice";
import serviceReducer from "../features/serviceSlice";
import trackReducer from "../features/trackSlice";
import userActionLogReducer from "../features/userActionLogSlice";
import reportReducer from "../features/reportSlice";
import queueTokenReducer from "../features/queueTokenSlice";

import notificationReducer from "../features/notificationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    company: companyReducer,
    companyUser: companyUserReducer,
    platformUser: platformUserReducer,
    role: roleReducer,
    module: moduleReducer,
    rolePermission: rolePermissionReducer,
    subscriptionPlan: subscriptionPlanReducer,
    branch: branchReducer,
    branchSetting: branchSettingReducer,
    signalr: signalrReducer,
    customer: customerReducer,
    service: serviceReducer,
    track: trackReducer,
    userActionLog: userActionLogReducer,
    report: reportReducer,
    queueToken: queueTokenReducer,
    notification: notificationReducer,
    [crudApi.reducerPath]: crudApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "signalr/connect",
          "signalr/disconnect",
          "auth/login/pending",
          "auth/login/fulfilled",
          "auth/login/rejected",
        ],
      },
    }).concat(crudApi.middleware),
});

export default store;
